import { Component, OnDestroy, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Button } from 'primeng/button';
import { FloatLabel } from 'primeng/floatlabel';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DialogAction } from '../../../../shared/contracts/dialog.interface';
import { InputText } from 'primeng/inputtext';
import { Textarea } from 'primeng/textarea';
import { Select } from 'primeng/select';
import {User} from '../../../../users/contracts/user.interface';
import {UserService} from '../../../../users/services/user.service';
import {MultiSelect} from 'primeng/multiselect';

export interface TeamDialogData {
  id?: number;
  name: string;
  description?: string;
  user_ids?: number[];
}

@Component({
  selector: 'app-team-dialog',
  standalone: true,
  imports: [
    Button,
    FloatLabel,
    ReactiveFormsModule,
    InputText,
    Textarea,
    MultiSelect
  ],
  templateUrl: './team-dialog.component.html',
  styleUrls: ['./team-dialog.component.scss']
})
export class TeamDialogComponent implements OnInit, OnDestroy {
  static readonly DIALOG_CONFIG: DynamicDialogConfig = {
    header: 'Team Data',
    width: '95vw',
    style: { 'max-width': '800px', 'min-height': 'auto'},
    modal: true,
    focusOnShow: false,
  };

  teamForm: FormGroup;
  users: any[] = []; // fetched from API

  private initForm(): FormGroup {
    return this.fb.group({
      name: ['', Validators.required],
      description: [''],
      user_ids: [[], Validators.required] // store as array
    });
  }

  constructor(
    private fb: FormBuilder,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private userService: UserService
  ) {
    this.teamForm = this.initForm();
  }

  ngOnInit() {
    this.userService.getAll(1, 1000).subscribe((res) => {
      this.users = res.data.map((u: User) => ({ ...u, id: Number(u.id) }));

      if (this.config.data) {
        const incoming = { ...this.config.data };

        incoming.user_ids = Array.isArray(incoming.user_ids)
          ? incoming.user_ids.map(Number)
          : [];

        this.teamForm.patchValue(incoming);
      }
    });
  }
  save() {
    const teamData: TeamDialogData = this.teamForm.value;
    this.ref.close({
      action: DialogAction.OK,
      data: teamData
    });
  }

  closeDialog() {
    this.ref.close({
      action: DialogAction.CLOSE,
    });
  }

  ngOnDestroy() {
    if (this.ref) {
      this.ref.close();
    }
  }
}
